<template>
  <div class="workbench-shell">
    <WorkBench_ArticelList v-if="workbench_type === 'reference'" :content="workbench_content" @clossWorkBench="clossWorkBench" />
    <WorkBench_WordSegmentList v-else-if="workbench_type === 'word_segment_search_res'" :content="workbench_content" @clossWorkBench="clossWorkBench" />
    <!-- <WorkBench_TopicAssistantList v-else-if="workbench_type === 'topic_selection_assistance'" :content="workbench_content" @clossWorkBench="clossWorkBench" /> -->
  </div>
</template>

<script>
/* eslint-disable */
import WorkBench_ArticelList from "../components/WorkBench_ArticelList.vue";
import WorkBench_WordSegmentList from "../components/WorkBench_WordSegmentList.vue";
// import WorkBench_TopicAssistantList from '../components/WorkBench_TopicAssistantList.vue';
export default {
  name: "WorkBench",
  components: {
    WorkBench_ArticelList,
    WorkBench_WordSegmentList,
    // WorkBench_TopicAssistantList,
  },
  props: {
    workbench_type: {
      // type: Object,
      required: true,
      // default: () => ({'type': null, 'content': null})
      // // 可以添加更具体的验证
      // validator: (value) => {
      // }
    },
    workbench_content: {
      // type: Object,
      required: true,
      // default: () => ({'type': null, 'content': null})
      // // 可以添加更具体的验证
      // validator: (value) => {
      // }
    },
  },
  // data() {
  //     type: workbenchData['type'],
  //     content: workbenchData['ceontent'],
  //   };
  // },
  // computed: {
  //   type() {
  //   },
  //   content() {
  //   }
  // },
  // computed: {
  //   // 解析文献列表数据
  //   articleList() {
  //     try {
  //       // 如果content是JSON字符串则解析，否则直接使用
  //         ? JSON.parse(this.workbenchData.content)
  //         : this.workbenchData.content;
  //     } catch (error) {
  //       console.error('解析文献数据失败:', error);
  //     }
  //   }
  // },
  // mounted() {
  //   // // 修复：初始化折叠状态（超过200字符的摘要默认折叠）
  //   // this.isCollapsed = this.articleList.map(
  //   //   article => article.description.length > 200
  //   // );
  // },
  methods: {
    // 传递子组件调用给爷爷组件的关闭方法
    clossWorkBench() {
      this.$emit("clossWorkBench");
    },
  },
};
</script>

<style scoped>
.workbench-shell {
  height: 100%;
  min-width: 420px;
  overflow: hidden;
  box-sizing: border-box;
}
</style>

<style scoped></style>
